export const COMMON_MESSAGE = {
    SOMETHING_WENT_WRONG: 'Something went wrong',
    MAINTENANCE_MESSAGE_1: 'Planned system maintenance is taking place from',
    MAINTENANCE_MESSAGE_2: ' Our website and login portals may be unavailable during this time.',
    FETCHING_ERROR_MESSAGE: 'There is a problem fetching your data. Please try to refresh the page.'
}